// Mode values are duplicated here because the settings endpoints publish no schema the frontend
// can generate types from. Keep every mode value in this file so there is one place to replace.

export const CONTACT_LLM_MODES = {
  INHERIT: "INHERIT",
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
};

// A customer with no stored row inherits. The API returns only the rows that are not INHERIT, so
// an absent customer and an explicit INHERIT describe the same state.
export const DEFAULT_CONTACT_LLM_MODE = CONTACT_LLM_MODES.INHERIT;

// Labels use business vocabulary: a code "contact" is a client's customer. These read differently
// from the channel labels on purpose — a channel answers whether Polly runs there, a customer
// answers what that customer's own setting is.
export const CONTACT_LLM_MODE_LABELS = {
  [CONTACT_LLM_MODES.INHERIT]: "Follow channel setting",
  [CONTACT_LLM_MODES.ENABLED]: "Enabled",
  [CONTACT_LLM_MODES.DISABLED]: "Disabled",
};

export const CONTACT_LLM_MODE_OPTIONS = [
  { value: CONTACT_LLM_MODES.ENABLED, label: CONTACT_LLM_MODE_LABELS.ENABLED },
  { value: CONTACT_LLM_MODES.DISABLED, label: CONTACT_LLM_MODE_LABELS.DISABLED },
  { value: CONTACT_LLM_MODES.INHERIT, label: CONTACT_LLM_MODE_LABELS.INHERIT },
];

// Shown in place of a mode value this build does not know, so a row stays readable and a stored
// value is never silently reported as off.
export const UNRECOGNIZED_CONTACT_LLM_MODE_LABEL = "Unrecognized setting";

export const isRecognizedContactLlmMode = (mode) =>
  Object.prototype.hasOwnProperty.call(CONTACT_LLM_MODES, mode);

export const contactLlmModeLabel = (mode) =>
  isRecognizedContactLlmMode(mode)
    ? CONTACT_LLM_MODE_LABELS[mode]
    : UNRECOGNIZED_CONTACT_LLM_MODE_LABEL;
